/*
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description: 全局注册组件
 */
function registerCpt(Vue) {
  if (registerCpt.installed) {
    return;
  }
}
export default registerCpt;
